module.exports = __webpack_public_path__ + "img/9.9.TU.f681c90d.png";